export const strawberryJam = {
  id: "strawberryJam",
  link: "/#/recipes/recipes/strawberryJam",
  name: "Strawberry Jam",
  cuisine: "Shin",
  summary: "Exotic on Roshar, this is normal for us.",
  inspiration: null,
  quantity: "6 half pints (6 cups)",
  time: "1 hour",
  notes:
    "This is a pretty standard strawberry jam recipe, though I've cut the sugar a bit, and increased the cook time to still get it to gel. The butter is to help reduce foaming. Any fat should work, so for a vegan option replace the butter with coconut or vegetable oil. The jam can be canned in glass jars, frozen in plastic containers, or refrigerated if you plan to eat it all within a week or so. I have not included a how-to on home canning here. If you want to learn how to can, I recommend going to official sources such as the USDA Complete Guide to Home Canning. I made this with strawberries from my garden, but there's no reason you couldn't use store-bought strawberries.",
  quotes:
    'He winked, turning the jar toward Shallan. It was deep, dark red. "Strawberry." "Never heard of it," Shallan said. "It’s exceedingly rare," Jasnah said, reaching for the jar. "Like most plants from Shinovar, it can’t grow other places." (The Way of Kings ch 48)',
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/strawberry-jam-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "strawberry",
          display: "12 cups strawberries"
        },
        {
          item: "butter",
          display: "1/2 tsp butter"
        },
        {
          item: "sugar",
          display: "3 cups granulated sugar"
        },
        {
          item: "pectin",
          display: "1 package low-sugar-required pectin"
        }
      ]
    }
  ],
  steps: [
    "Remove stems and leaves from strawberries. Crush them to a chunky pulp - it should result in about 6 cups.",
    "Put crushed strawberries in a medium-sized pot. Add butter and sugar. Sprinkle pectin over the sugar.",
    "Mix everything together, bring to boil over high heat. Reduce heat to medium, then simmer 20-30 minutes until gelled.",
    "To tell when the mixture has hit the gel point, either use a cooking thermometer (gel point is 220 degrees Fahrenheit at sea level, and decreases with elevation) or dip a spoon in the boiling mixture, pop the spoon in the freezer for a minute to cool, then see if the jam on the spoon has hit a consistency that you like yet. You'll want to look for a skin forming over the spoon, and the jam not just being thickened, but gelled up and holding together.",
    "If you can the jam, leave 1/4 inch headspace and process for 10 minutes (longer at higher elevations).",
    "To freeze the jam, place the jam in plastic containers, and freeze."
  ]
}
